import { toast } from '@/components/ui/toast';

const DEFAULT_ERROR_MESSAGE = 'Please try again.';

const getErrorMessage = (error: unknown, fallback = DEFAULT_ERROR_MESSAGE) =>
  error instanceof Error && error.message ? error.message : fallback;

type NotificationControlOptions = {
  suppressGlobalNotification?: boolean;
};

const canNotify = (options?: NotificationControlOptions) => !options?.suppressGlobalNotification;

export const notifyMutationSuccess = (title: string, message?: string) => {
  toast.success({
    duration: 3 * 1000,
    title,
    description: message,
  });
};

export const notifyMutationError = (title: string, error: unknown, fallbackMessage?: string) => {
  toast.error({
    duration: 3 * 1000,
    title,
    description: getErrorMessage(error, fallbackMessage),
  });
};

export const notifyMutationSuccessWithOptions = (
  options: NotificationControlOptions = { suppressGlobalNotification: false },
  title: string,
  message?: string
) => {
  if (!canNotify(options)) return;
  notifyMutationSuccess(title, message);
};

export const notifyMutationErrorWithOptions = (
  options: NotificationControlOptions = { suppressGlobalNotification: false },
  title: string,
  error: unknown,
  fallbackMessage?: string
) => {
  if (!canNotify(options)) return;
  notifyMutationError(title, error, fallbackMessage);
};
